import type { PublicRuntimeConfig } from "@nuxt/schema"

export function getLocationIdsFromSlugs({ cms }: Pick<PublicRuntimeConfig, "cms">): {
  om: Record<string, number>
  studentliv: Record<string, number>
} {
  return {
    om: sanitize({
      kjoepsvilkaar: cms.om.termsOfPurchaseLocationId,
      personvern: cms.om.privacyPolicyLocationId,
      kundeservice: cms.om.customerServiceLocationId,
      "les-om-informasjonskapsler": cms.om.cookiePolicyLocationId,
      "om-kunne": cms.om.aboutUsLocationId,
    }),
    studentliv: sanitize({
      "5-raad-for-aa-lykkes-og-staa-paa-eksamen": cms.studentliv.fiveTipsLocationId,
      "hvordan-bestaa-exphil": cms.studentliv.howToPassExphilLocationId,
      "10-raad-for-aa-studere-best-mulig": cms.studentliv.tenTipsLocationId,
      "faa-vaare-beste-tips-og-triks-til-eksamen": cms.studentliv.getOurBestTipsLocationId,
    }),
  }
}

function sanitize(raw: Record<string, string>) {
  return Object.entries(raw).reduce<Record<string, number>>((acc, [key, value]) => {
    const parsed = Number.parseInt(value, 10)
    if (!Number.isNaN(parsed)) {
      acc[key] = parsed
    }
    return acc
  }, {})
}
